import React, { useRef } from "react";


import Intro from "./components/Intro/Intro";
import ImageSplit from "./components/ImageSplit/ImageSplit";
import IntroDescriptionOne from "./components/IntroDescriptionOne/IntroDescriptionOne";
import IntroDescriptionTwo from "./components/IntroDescriptionTwo/IntroDescriptionTwo";

import ImageDecorator from "./components/ImageDecorator/ImageDecorator";

import './IntroPage.css'
import './Divisions.css'

import img_muaythai from "../shared/images/ImageSplit/MuayThai.jpg"
import img_kettlebell from "../shared/images/ImageSplit/Kettlebell.jpg"
import img_powerlifting from "../shared/images/ImageSplit/Powerlifting.jpg"
import img_bodybuilding from "../shared/images/ImageSplit/Bodybuilding.jpg"

import { NavLink } from 'react-router-dom';
import { FaLink, FaRegFilePdf } from "react-icons/fa"


const Divisions = function (props) {

    const descriptionRef = useRef();


    return (

        <React.Fragment>



            <br />
            <br />
            <br />
            <div className="page-body">
                <div className="page-content">

                    <div className="container-box">
                        <div class="divisions_content">
                            <div class="divisions_img float_right">
                                <ImageDecorator image={img_muaythai} />
                            </div>

                            <h2 className="divisions-h1"><span>Muay Thai</span></h2>

                            <p>
                                Das Muay Thai ist aus den alten Kriegskünsten der thailändischen Soldaten entstanden, welche sich aus reinem Kampf ums Überleben, über Jahrtausende hinweg, entwickelt haben.
                                Da diese Art mit Ellenbogen, Knien, Faust- und Fußtechniken zu kämpfen sehr erfolgreich war, entwickelte man daraus ein effektives Selbstverteidigungssystem. Dieses System umfasst Abwehr- und Kontertechniken, des weiteren beinhaltet es auch Hebel- und Würgetechniken sowie Techniken des Bodenkampfes. Das thailändische Boxen wurde früher als vormilitärische Ausbildung unterrichtet. Bei den Wettkämpfen gab es damals weder Geeichtsklassen noch zeitlich limitierte Runden. Es gab fast keine Regeln und auf Turnieren wurde ohne jegliche Schutzausrüstung gekämpft.
                            </p>

                            <p>
                                1929 wurden zahlreiche Regeln ( Geeichtsklassen, Schutzausrüstung...) eingeführt und machten diese alte Kampfkunst zu einem attraktiven Wettkampfsport. Inzwischen ist in vielen Ländern der Erde das Muay Thai ( Thaiboxen ) bereits vom nationalem olympischen Komitee anerkannt.
                                In beiden Sportarten steht trotz aller Härte die Fairness im Vordergrund. Das heißt, Disziplin und Respekt vor Trainer und Gegner sind Grundvoraussetzung.
                            </p>


                            <div className="blockquote-wrapper">
                                <div className="blockquote">
                                    <h1>
                                        Der Weg zum Ziel im Muay Thai ist hart und lang. Nutze immer Deinen Verstand und respektiere die, welche Dich anleiten und trainieren!
                                    </h1>
                                    <h4>Daotong Sityodtong</h4>
                                </div>
                            </div>
                            <br></br>

                            <p>
                                Im Thaiboxen kommen alle klassischen Boxschläge (Mhad) aus den Boxen und alle Tritte ( Theep/Dteh)  aus dem Kickboxen zum Einsatz. Zusätzlich noch alle bekannten Techniken mit dem Knie ( Khao) oder dem Ellenbogen ( Sok) .
                            </p>
		            <div className='tab'>
                                <table border='0' cellPadding='0' cellSpacing='0'>
                                    <tbody>
                                        <tr className='days'>
                                            <th></th>
                                            <th>Montag</th>
                                            <th>Dienstag</th>
                                            <th>Mittwoch</th>
                                            <th>Donnerstag</th>
                                            <th>Freitag</th>
                                        </tr>
                                        <tr>
                                            <td className='time'>17:00</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td rowSpan="2" className='cs335 red1' data-tooltip='Kettlebell/ Fightforce Ausbildung  17:00 bis 18:00'>Kettlebell/<br />Fightforce Ausb.</td>
                                        </tr>
                                        <tr>
                                            <td className='time'>17:30</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td className='time'>18:00</td>
                                            <td rowSpan="3" className='cs335 red2' data-tooltip='Muaythai/K1 Fortgeschrittene  18:00 bis 19:30'>Muaythai/K1<br />Fortgeschrittene</td>
                                            <td rowSpan="3" className='cs335 red2' data-tooltip='Muaythai/K1 Fortgeschrittene  18:00 bis 19:30'>Muaythai/K1<br />Fortgeschrittene</td>
                                            <td rowSpan="3" className='cs335 red2' data-tooltip='Muaythai/K1 Fortgeschrittene  18:00 bis 19:30'>Muaythai/K1<br />Fortgeschrittene</td>
                                            <td rowSpan="3" className='cs335 red2' data-tooltip='Muaythai/K1 Fortgeschrittene  18:00 bis 19:30'>Muaythai/K1<br />Fortgeschrittene</td>
                                            <td rowSpan="3" className='cs335 red2' data-tooltip='Muaythai/K1 Fortgeschrittene  18:00 bis 19:30'>Muaythai/K1<br />Fortgeschrittene</td>
                                        </tr>
                                        <tr>
                                            <td className='time'>18:30</td>
                                        </tr>
                                        <tr>
                                            <td className='time'>19:00</td>
                                        </tr>
                                        <tr>
                                            <td className='time'>19:30</td>
                                            <td rowSpan="3" className='cs335 red1' data-tooltip='Sanda/ Kickboxen  19:30 bis 21:00'>Sanda /<br />Kickboxen</td>
                                            <td rowSpan="3" className='cs335 red1' data-tooltip='Sanda/ Kickboxen & Muaythai Anfänger  19:30 bis 21:00'>Sanda / Kickboxen<br /><br />Muaythai Anfänger</td>
                                            <td rowSpan="3" className='cs335 red1' data-tooltip='Sanda/ Kickboxen  19:30 bis 21:00'>Sanda /<br />Kickboxen</td>
                                            <td rowSpan="3" className='cs335 red1' data-tooltip='Sanda/ Kickboxen & Muaythai Anfänger  19:30 bis 21:00'>Sanda / Kickboxen<br /><br />Muaythai Anfänger</td>
                                            <td rowSpan="3" className='cs335 red1' data-tooltip='Sanda/ Kickboxen  19:30 bis 21:00'>Sanda /<br />Kickboxen</td>
                                        </tr>
                                        <tr>
                                            <td className='time'>20:00</td>
                                        </tr>
                                        <tr>
                                            <td className='time'>20:30</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* <div class="divisions_img float_left">
                                <ImageDecorator image={img_muaythai} />
                            </div> */}

                            <p>
                                Wenn du Interesse an einem Probetraining hast, melde dich bitte telefonisch bei <NavLink className="underline cs-text-link" to="/impressum" exact="true"><FaLink className="icon-link-text " /> uns</NavLink> und wir besprechen alles Weitere.
                            </p>


                        </div>




                    </div>

                    <br />
                    <br />

                    <div className="container-box">
                        <div class="divisions_content">
                            <div class="divisions_img float_left">
                                <ImageDecorator image={img_kettlebell} />
                            </div>

                            <h2 className="divisions-h1"><span>Kettlebells</span></h2>

                            <p>
                                Combat Sports Lübeck e.V. ist offizieller Ausbildungsstützpunkt im Norden Deutschlands für RKC- Hardstyle Kettlebelltraining. Die Kettlebell ist unglaublich vielseitig. Lerne bei uns den Umgang mit der Kettlebell und zwar richtig!
                            </p>
                            <p>
                                Mehr Kraft durch die Grinds (Press, Squat und Turkish Get up)
                            </p>
                            <p>
                                Mehr Power und Ausdauer durch die Ballistics (Swing, Clean und Snatch)
                            </p>
                            <p>
                                Du lernst Körperspannung und richtige Atmung. Werde einfach besser durch die Ausbildung mit diesem Tool. Egal ob Sportler oder Coach... Bei Fragen, wie zum Beispiel wann die nächste Ausbildung startet, melde dich gerne bei <NavLink className="underline cs-text-link" to="/impressum" exact="true"><FaLink className="icon-link-text " /> uns</NavLink>!
                            </p>



                            {/* <div class="divisions_img float_left">
                                <ImageDecorator image={img_muaythai} />
                            </div> */}



                        </div>




                    </div>


                    <br />
                    <br />

                    <div className="container-box">
                        <div class="divisions_content">
                            <div class="divisions_img float_right">
                                <ImageDecorator image={img_powerlifting} />
                            </div>

                            <h2 className="divisions-h1"><span>Powerlifting</span></h2>

                            <p>
                                Powerlifting, in Deutschland auch unter Kraftdreikampf bekannt, dreht sich alles um die Disziplinen Kniebeuge, Bankdrücken und Kreuzheben.
                                Ziel ist es dabei ein möglichst hohes Gewicht einmal zu bewegen.
                                Genaue Regelwerke können zum Beispiel beim Bundesverband Deutscher Kraftdreikämpfer e.V. (<a class="underline cs-text-link" href="https://bvdk.de/"><FaLink className="icon-link-text " />BVDK</a>.) eingesehen werden.
                            </p>

                            <p>
                                Bei uns stehen dir 11 Racks, eine Vielzahl von Langhanteln, Specialty Bars und vieles mehr zur Verfügung. Diese umfassende Ausrüstung bietet die perfekte Grundlage für ein erfolgreiches und abwechslungsreiches Training.
                            </p>

                            <p>
                                Egal, ob du ein erfahrener Powerlifter oder ein Neuling in diesem aufregenden Sport bist,
                                unsere Sparte ist offen für alle, die zusammen stärker werden wollen.
                            </p>


                            {/* <div class="divisions_img float_left">
                                <ImageDecorator image={img_muaythai} />
                            </div> */}



                        </div>




                    </div>


                    <br />
                    <br />

                    <div className="container-box">
                        <div class="divisions_content">
                            <div class="divisions_img float_left">
                                <ImageDecorator image={img_bodybuilding} />
                            </div>

                            <h2 className="divisions-h1"><span>Bodybuilding</span></h2>

                            <p>
                                Ob du stärker werden möchtest, eine beeindruckende Körperästhetik anstrebst oder sogar den Weg zu Wettkämpfen suchst, bei uns ist alles möglich. Zusätzlich zu Kettlebells, Kurzhanteln bis hoch zu 75kg und den Racks haben wir auch einige spezialisierte Maschinen wie Belt Squat oder ein Pendulum Squat
                                - so findest du bestimmt alles an Ausrüstung um deine Ziele zu erreichen.
                            </p>


                            {/* <div class="divisions_img float_left">
                                <ImageDecorator image={img_muaythai} />
                            </div> */}



                        </div>




                    </div>

                </div>

            </div>









            {/* <div className="page-body">
                <div className="page-content">
                    <div className="promo" >
                        <div className="image-wrapper"><img src="https://images.unsplash.com/photo-1554620121-59e7f3f6e3a4?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ" /></div>
                        <h2 className="title" data-cta="Get out there TEST TEST→">Nightlife</h2>
                    </div>
                </div >
            </div > */}


            {/* <div className="page-body">
                <div className="page-content">

                    <IntroDescriptionTwo />

                </div>

            </div> */}








        </React.Fragment >
    )
}

export default Divisions
